import { doc, setDoc } from 'firebase/firestore';
import { db } from '../../lib/firebase';

// Per-tenant settings → config/{tenantId} (gated owner/hqadmin by rules).
export function saveConfig(tenantId, partial) {
  return setDoc(doc(db, 'config', tenantId), partial, { merge: true });
}
